var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.children
    ? _c("div", { staticClass: "menu", on: { click: _vm.handleJump } }, [
        _vm._v(
          "\n  " +
            _vm._s(
              _vm.index || _vm.index === 0
                ? "" +
                    (_vm.item.isparent ? "" : "(") +
                    (_vm.index + 1) +
                    (_vm.item.isparent ? "." : ")") +
                    " "
                : ""
            ) +
            _vm._s(_vm.item.meta.title) +
            "\n"
        ),
      ])
    : _c(
        "div",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              _vm._s(_vm.index || _vm.index === 0 ? _vm.index + 1 + ". " : "") +
                _vm._s(_vm.item.meta.title)
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.item.children, function (child, index) {
            return _c("SideMenuItem", {
              key: index,
              staticClass: "nest-menu",
              attrs: {
                index: index,
                item: child,
                "base-path": _vm.resolvePath(child.path),
              },
            })
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }